import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import { GetLastVersionByPlatformAndTargetGQL, PlatformEnum, VersionType } from '@sifca-monorepo/widget-generator';

@Injectable({
  providedIn: 'root',
})
export class MobileVersionService {
  private lastVersion = new BehaviorSubject<VersionType | null>(null);

  get lastVersion$(): Observable<VersionType | null> {
    return this.lastVersion.asObservable();
  }

  constructor(private getLastVersionByPlatformAndTargetGQL: GetLastVersionByPlatformAndTargetGQL) {}

  getLastVersionByPlatformAndTarget(platform: PlatformEnum): Observable<VersionType | null> {
    return this.getLastVersionByPlatformAndTargetGQL.fetch({ platform, target: { pos: localStorage.getItem('posId') } }).pipe(
      map(({ data }: any) => {
        const version = data.getLastVersionByPlatformAndTarget;
        this.lastVersion.next(version);
        return version;
      }),
    );
  }
}